import React from "react";
import HighlightsList from "../highlights-list";
import HorizontalContentBlock from "../content-block-horizontal";
import styled from "styled-components";


const StyledHighlightsList = styled(HighlightsList)`
  margin-top: 0.4rem;
`;


const TopFeatureBlock = ({title, content, list, callToAction, ...props}) => {
  return (
    <HorizontalContentBlock
      contentPosition='left'
      waveOrientation='topBalanced'
      wavePosition='inset'
      waveHeight={250}
      mode='solid'
      title={title}
      content={content}
      footer={<>
        <StyledHighlightsList {...list}/>
        {callToAction}
      </>}
      {...props} />
  )
}

export default TopFeatureBlock;
